import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Logger } from '@app/core/services/logger.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { JwtService } from '@app/core/services/jwt.service';
const log = new Logger('AuthenticationGuard');

@Injectable()
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private jwtService: JwtService) {
  }
  canActivate(currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot): boolean {
    let path = currentState.url;
    if (path === '/login' || path.indexOf('/identity') != -1 || path === '/register' || path.indexOf('/resetpassword') != -1 || path === '/registersuccessful') {
      if (path === '/register' && this.jwtService.getIdentity() == null) {
        this.router.navigate(['/identity'], { replaceUrl: true });
      }
      return true;
    } else {
      if (this.authenticationService.isAuthenticated()) {
        return true;
      }
      log.debug('Not authenticated, redirecting...');
      this.router.navigate(['/login'], { replaceUrl: true });
      return false;
    }
  }
}
